export default "__VITE_ASSET__fbc7c32b__"